import React from 'react';
import Topslider from '../../Components/Homecomp/Calccomp/Topslider';
import Delcomps from '../../Components/Homecomp/Delcomps/Delcomps';


export default function Delpage() {
  return (
    <div>
        
        <Topslider/>
        <Delcomps/>
    </div>
  )
}
